<template>
  <div v-wechat-title="title" style="height:100%">
    <el-row>
      <el-col :span="20" class="padding10 padding-none-v" ><h3 class="align-left">病房接患者</h3></el-col>
      <el-col :span="4" class="align-right padding10">
        <el-button  type="warning" size="mini" @click="saveChanges"><i class="el-icon-loading" v-if="!finished"></i>保存</el-button>
      </el-col>
    </el-row>
    <DocFrame  ref="doc" :resetHeight="false" :style="{height:`${this.screenHeight-100}px`}" class="padding10" :docno="this.$root.DOCUMENT.HZZY050" :guid="docguid" :surgeryId="`cy${surgery_no}`"
    :docname="docguid"  @saved="afterDocumentSaved"></DocFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BFJHZ`,
    props: {

    },
    data() {
        return {
            title: `病房接患者-常州`,
            surgery_no: this.$route.query.surgery_no,
            finished: true
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        docguid() {
            return `常州病房接患者_cy${this.surgery_no}_${this.$root.DOCUMENT.HZZY050}`
        }

    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.doc.loadDocument()
        })
    },
    methods: {
        afterDocumentSaved() {
            this.finished = true
        },
        saveChanges() {
            let that = this
            if (that.finished) {
                that.finished = false
                this.$refs.doc.save()
            }
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Transfer/BFJHZ.vue